import { application } from './application.js'
import GtmEventsController from './gtm_events_controller'
import LemonwayIframeController from './lemonway_iframe_controller'
import PromoCodeController from './promo_code_controller'
import BreadcrumbController from './signature/breadcrumb_controller'
import ContractController from './signature/contract_controller'
import ProgressController from './signature/progress_controller'
import SignatureController from './signature/signature_controller'
import SubscriptionStepsController from './signature/subscription_steps_controller'
import SubmitConfirmationController from './submit_confirmation_controller'
import SddMandateController from './sdd_mandate_controller'
import TomSelectController from './tom_select_controller.js'
import RedactorController from './redactor_controller.js'
import NestedFormController from './nested_form_controller.js'
import LendingTimetableFormController from './lending_timetable_form_controller.js'
import RoyaltiesTimetableFormController from './royalties_timetable_form_controller.js'
import PasswordVisibilityController from './password_visibility_controller.js'
import ClipboardController from './clipboard_controller.js'
import NavbarScrollController from './navbar_scroll_controller.js'
import PresetAmountController from './preset_amount_controller.js'
import FileDropController from './file_drop_controller.js'
import DoughnutChartController from './doughnut_chart_controller.js'
import ToastController from './toast_controller.js'
import AddressAutocompleteController from './address_autocomplete_controller.js'
import CarouselController from './carousel_controller.js'
import WebShareController from './web_share_controller.js'
import SubscriptionFormController from './subscription_form_controller.js'
import GalleryFilterController from './gallery_filter_controller.js'
import TabNavController from './tab_nav_controller.js'
import LendingSimulatorController from './lending_simulator_controller.js'
import RoyaltiesSimulatorController from './royalties_simulator_controller.js'
import CompoundSimulatorController from './compound_simulator_controller.js'
import AcceptTermsModalController from './accept_terms_modal_controller.js'
import TabTypeSelectorController from './tab_type_selector_controller.js'
import TabMemoryController from './tab_memory_controller.js'
import StickyBarController from './sticky_bar_controller.js'

// Register controllers
application.register('gtm-events', GtmEventsController);
application.register('lemonway-iframe', LemonwayIframeController);
application.register('promo-code', PromoCodeController);
application.register('signature-breadcrumb', BreadcrumbController);
application.register('signature-contract', ContractController);
application.register('signature-progress', ProgressController);
application.register('signature', SignatureController);
application.register('signature-subscription-steps', SubscriptionStepsController);
application.register('submit-confirmation', SubmitConfirmationController);
application.register('sdd-mandate', SddMandateController);
application.register('tom-select', TomSelectController);
application.register('redactor', RedactorController);
application.register('nested-form', NestedFormController);
application.register('lending-timetable-form', LendingTimetableFormController);
application.register('royalties-timetable-form', RoyaltiesTimetableFormController);
application.register('password-visibility', PasswordVisibilityController);
application.register('clipboard', ClipboardController);
application.register('navbar-scroll', NavbarScrollController);
application.register('preset-amount', PresetAmountController);
application.register('file-drop', FileDropController);
application.register('doughnut-chart', DoughnutChartController);
application.register('toast', ToastController);
application.register('address-autocomplete', AddressAutocompleteController);
application.register('carousel', CarouselController);
application.register('web-share', WebShareController);
application.register('subscription-form', SubscriptionFormController);
application.register('gallery-filter', GalleryFilterController);
application.register('tab-nav', TabNavController);
application.register('lending-simulator', LendingSimulatorController);
application.register('royalties-simulator', RoyaltiesSimulatorController);
application.register('compound-simulator', CompoundSimulatorController);
application.register('accept-terms-modal', AcceptTermsModalController);
application.register('tab-type-selector', TabTypeSelectorController);
application.register('tab-memory', TabMemoryController);
application.register('sticky-bar', StickyBarController);
